module.exports = __webpack_public_path__ + "img/home-invest.d1171c9e.svg";